import { render, staticRenderFns } from "./personageStatistics.vue?vue&type=template&id=73996c85&scoped=true&"
import script from "./personageStatistics.vue?vue&type=script&lang=js&"
export * from "./personageStatistics.vue?vue&type=script&lang=js&"
import style0 from "./personageStatistics.vue?vue&type=style&index=0&id=73996c85&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73996c85",
  null
  
)

export default component.exports